"use strict";

exports.__esModule = true;
exports.deviceDataDefinition = void 0;
var deviceDataDefinition = exports.deviceDataDefinition = function deviceDataDefinition(translate) {
  return {
    columns: [{
      id: "timestamp",
      name: translate("DataTable.Column.Title.Timestamp", "Timestamp"),
      type: "date",
      dateFormat: "ShortDateTime",
      usePlantTime: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "data_item_type",
      name: translate("DataTable.Column.Title.DataItemType", "Data Item Type"),
      type: "string",
      canSearch: true,
      canFilter: true
    }, {
      id: "data_item_name",
      name: translate("DataTable.Column.Title.DataItemName", "Data Item Name"),
      type: "string",
      canSearch: true,
      canFilter: true
    }, {
      id: "sub_type",
      name: translate("DataTable.Column.Title.SubType", "Sub Type"),
      type: "string",
      canSearch: true,
      canFilter: true
    }, {
      id: "value",
      name: translate("DataTable.Column.Title.Value", "Value"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "category",
      name: translate("DataTable.Column.Title.Category", "Category"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "units",
      name: translate("DataTable.Column.Title.Units", "Units"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "condition_text",
      name: translate("DataTable.Column.Title.ConditionText", "Condition Text"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "condition_level",
      name: translate("DataTable.Column.Title.ConditionLevel", "Condition Level"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "native_code",
      name: translate("DataTable.Column.Title.NativeCode", "Native Code"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "native_severity",
      name: translate("DataTable.Column.Title.NativeSeverity", "Native Severity"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }, {
      id: "qualifier",
      name: translate("DataTable.Column.Title.Qualifier", "Qualifier"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true
    }],
    parseData: function parseData(responseData) {
      var value = null;
      var isDefined = function isDefined(val) {
        return val !== undefined;
      };
      if (isDefined(responseData.value_event)) {
        value = responseData.value_event;
      } else if (isDefined(responseData.value_sample)) {
        value = responseData.value_sample;
      } else if (isDefined(responseData.value_path_position)) {
        var _responseData$value_p = responseData.value_path_position,
          _responseData$value_p2 = _responseData$value_p.x,
          x = _responseData$value_p2 === void 0 ? "" : _responseData$value_p2,
          _responseData$value_p3 = _responseData$value_p.y,
          y = _responseData$value_p3 === void 0 ? "" : _responseData$value_p3,
          _responseData$value_p4 = _responseData$value_p.z,
          z = _responseData$value_p4 === void 0 ? "" : _responseData$value_p4;
        value = x + "-" + y + "-" + z;
      }
      return Object.assign({}, responseData, {
        value: value
      });
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: true,
        defaultPageSize: "auto",
        columns: [{
          id: "timestamp",
          name: translate("DataTable.Column.Title.Timestamp", "Timestamp"),
          type: "date",
          dateFormat: "ShortDateTime",
          usePlantTime: true,
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "data_item_type",
          name: translate("DataTable.Column.Title.DataItemType", "Data Item Type"),
          type: "string",
          canSearch: true,
          canFilter: true
        }, {
          id: "data_item_name",
          name: translate("DataTable.Column.Title.DataItemName", "Data Item Name"),
          type: "string",
          canSearch: true,
          canFilter: true
        }, {
          id: "sub_type",
          name: translate("DataTable.Column.Title.SubType", "Sub Type"),
          type: "string",
          canSearch: true,
          canFilter: true
        }, {
          id: "value",
          name: translate("DataTable.Column.Title.Value", "Value"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "category",
          name: translate("DataTable.Column.Title.Category", "Category"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "units",
          name: translate("DataTable.Column.Title.Units", "Units"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "condition_text",
          name: translate("DataTable.Column.Title.ConditionText", "Condition Text"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "condition_level",
          name: translate("DataTable.Column.Title.ConditionLevel", "Condition Level"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "native_code",
          name: translate("DataTable.Column.Title.NativeCode", "Native Code"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "native_severity",
          name: translate("DataTable.Column.Title.NativeSeverity", "Native Severity"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "qualifier",
          name: translate("DataTable.Column.Title.Qualifier", "Qualifier"),
          type: "string",
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }]
      };
    }
  };
};